export const getPlantYogurtPackage = newProduct => {
  let newPlantYogurtPackage = {
    UPC: newProduct.UPC,
    VitaminD: newProduct.VitaminD,
    SweetenerCertification: newProduct.SweetenerCertification,
    Sugar: newProduct.Sugar,
    SugarCertification: newProduct.SugarCertification,
    Calcium: newProduct.Calcium,
    CalciumCertification: newProduct.CalciumCertification,
    Protein: newProduct.Protein,
    ProteinCertification: newProduct.ProteinCertification,
    PlantYogurtAltType: newProduct.PlantYogurtAltType,
    FatLevel: newProduct.FatLevel,
    Flavor: newProduct.Flavor,
    Size: newProduct.Size,
    MultiPackageType: newProduct.MultiPackageType,
  }

  if (newProduct.PlantYogurtAltType === 'Other') {
    newPlantYogurtPackage.OtherPlantYogurtAltType =
      newProduct.OtherPlantYogurtAltType
  }

  if (newProduct.Flavor === 'Other') {
    newPlantYogurtPackage.OtherFlavor = newProduct.OtherFlavor
  }

  if (newProduct.MultiPackageType === true) {
    newPlantYogurtPackage.MultiPackageCount = newProduct.MultiPackageCount
  }

  return newPlantYogurtPackage
}

export const updatePlantYogurtPackage = newProduct => {
  let newPlantYogurtPackage = {
    UPC: newProduct.UPC,
    VitaminD: newProduct.VitaminD,
    SweetenerCertification: newProduct.SweetenerCertification,
    Sugar: newProduct.Sugar,
    SugarCertification: newProduct.SugarCertification,
    Calcium: newProduct.Calcium,
    CalciumCertification: newProduct.CalciumCertification,
    Protein: newProduct.Protein,
    ProteinCertification: newProduct.ProteinCertification,
    PlantYogurtAltType: newProduct.PlantYogurtAltType,
    FatLevel: newProduct.FatLevel,
    Flavor: newProduct.Flavor,
    Size: newProduct.Size,
    MultiPackageType: newProduct.MultiPackageType,
  }

  if (newProduct.PlantYogurtAltType === 'Other') {
    newPlantYogurtPackage.OtherPlantYogurtAltType =
      newProduct.OtherPlantYogurtAltType
  }

  if (newProduct.Flavor === 'Other') {
    newPlantYogurtPackage.OtherFlavor = newProduct.OtherFlavor
  }

  if (newProduct.MultiPackageType === true) {
    newPlantYogurtPackage.MultiPackageCount = newProduct.MultiPackageCount
  }

  return newPlantYogurtPackage
}
